import { Component, OnInit, Input, AfterViewChecked } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { GrupoService } from './grupo.service';
import { Grupo } from './grupo';
import { Usuario } from './../usuario/usuario';

declare var Materialize:any;

@Component({
  selector: 'app-adicionar-usuario',
  templateUrl: './adicionar-usuario.component.html',
  providers: [GrupoService]
})
export class AdicionarUsuarioComponent implements OnInit, AfterViewChecked {
  public busy: Promise<any>;
  public titulo: string = "Adicionar Usuario ao Grupo";
  public usuarios: any[];
  public usuario_no_grupo: Usuario[];
  public params:any = {nome: ""};
  public usuario_fora_grupo: Usuario[];
  public paginaAtual: number = 1;
  public itensPorPagina: number = 1;
  public totalItens: number = 1;
  public grupo_id: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private grupoService: GrupoService
  ) {  }

  getUsuariosGrupo(): void {
    this.route.params.forEach((params: Params) => {
      let id = params['id'];
      this.grupo_id = id;
      if(id !== undefined ){
        console.log('console: ', this.params);
        this.params['page'] = this.paginaAtual;
        
        this.busy = this.grupoService.getUsuariosGrupo(id, this.params)
          .then(retorno => this.setVariaveis(retorno));
      }
    });
  }

 

  pageChanged(page: any): void{
    this.paginaAtual = page;
    this.getUsuariosGrupo();
  }

  setVariaveis(retorno: any[]):void{
    this.usuario_no_grupo = retorno['usuarios_no_grupo'];
    this.usuario_fora_grupo = retorno['usuarios_fora_grupo'].data;

    this.paginaAtual = retorno['usuarios_fora_grupo'].current_page;
    this.totalItens = retorno['usuarios_fora_grupo'].total;
    this.itensPorPagina = retorno['usuarios_fora_grupo'].per_page;
  }

  AdicionarOuRemoveDoGrupo(usuario:Usuario): void{
    let indice_no_grupo = this.usuario_no_grupo.indexOf( usuario );
    let indice_fora_grupo = this.usuario_fora_grupo.indexOf( usuario );

    if(indice_no_grupo != -1){

      this.usuario_no_grupo.splice(indice_no_grupo, 1);
      this.usuario_fora_grupo.push(usuario);

      this.grupoService.addOrDelUsuarioGrupo(this.grupo_id, usuario.id, 'del');
    } else {

      this.usuario_fora_grupo.splice(indice_fora_grupo, 1);
      this.usuario_no_grupo.push(usuario);

      this.grupoService.addOrDelUsuarioGrupo(this.grupo_id, usuario.id, 'add');
    }

  }

  ngOnInit() {
    this.getUsuariosGrupo();
  }

  ngAfterViewChecked() {
    Materialize.updateTextFields();
  }

}



// WEBPACK FOOTER //
// ./src/app/grupos/adicionar-usuario.component.ts